import { type ReactNode, createContext, useContext, useEffect, useMemo } from 'react'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { NewInboxStepsStore } from 'pages/settings/pages/inboxes/pages/newInbox/store/newInboxStepsStore'
import { useSettingsContext } from 'pages/settings/context/settingsContext'

const NewInboxStepsContext = createContext<NewInboxStepsStore | null>(null)

export const useNewInboxStepsContext = () => {
  const context = useContext(NewInboxStepsContext)

  if (context === null)
    throw new Error('You have forgotten to wrap your root component with NewInboxStepsProvider')

  return context
}

export const NewInboxStepsProvider = ({ children }: { children: ReactNode }) => {
  const entities = useEntitiesContext()
  const settings = useSettingsContext()
  const store = useMemo(() => new NewInboxStepsStore(settings, entities), [])

  useEffect(() => {
    void store.init()
  }, [])

  return <NewInboxStepsContext.Provider value={store}>{children}</NewInboxStepsContext.Provider>
}
